import { APP_INITIALIZER, NgModule } from '@angular/core';
import '@df/catalog-ui/recently-viewed/recently-viewed-engine';
import { RecentlyViewedService } from '@df/catalog-ui/recently-viewed/recently-viewed.service';

@NgModule({
    providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: (recentlyViewedService: RecentlyViewedService) => () => {
                recentlyViewedService.appInitialize();
            },
            deps: [RecentlyViewedService],
            multi: true
        }
    ]
})
export class RecentlyViewedModule {}
